import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import MaterialReactTable from "material-react-table";
import {
  Button, Spinner, Toast, ToastBody, ToastHeader, Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import useAxios from "../../sections/useAxios";

const Feedbacks = () => {

  const api = useAxios();
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const {
    data,
    isLoading: companiesLoading,
    isError,
    error,
  } = useQuery(
    ["feedback-list"],
    async () => {
      const res = await api.get(`company/all-feedbacks`);
      return res.data;
    },
    { cacheTime: 0 }
  );

  const companies = data ?? [];

  useEffect(() => {
    if (isError) {
      setToastMsg(error.message || "Something went wrong");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 4000);
    }
  }, [isError, error]);

  const columns = [
    { accessorKey: "id", header: "ID", size: 50 },
    {
      accessorKey: "name",
      header: "Name",
    },
    { accessorKey: "email", header: "Email" },
    {
      accessorKey: "user_type",
      header: "User Type",
      Cell: ({ cell }) => {
        const value = cell.getValue();

        let colorClass = "secondary"; // default
        if (value?.toLowerCase() === "investor") colorClass = "bg-success";
        else if (value?.toLowerCase() === "company") colorClass = "primary-bg";

        return (
          <span className={`badge ${colorClass}`} style={{ fontSize: "0.85rem" }}>
            {value == "company" ? "Company" : value == "investor" && "Investor"}
          </span>
        );
      },
    },
    {
      accessorKey: "message",
      header: "Feedback",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ row }) => (
        <i
          className="fa-solid fa-clipboard-list fa-xl text-primary"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setSelectedUser(row.original);
            setModalOpen(true);
          }}
        ></i>
      ),
    },
    {
      accessorKey: "created_at",
      header: "Created At",
      Cell: ({ cell }) =>
        new Date(cell.getValue()).toLocaleDateString(),
    },
  ];

  return (
    <div className="container mt-4">
      <h4 className="primary-color fw-bold">All Feedbacks</h4>

      {companiesLoading && (
        <div className="d-flex justify-content-center align-items-center my-4">
          <Spinner color="primary" />
        </div>
      )}

      {showToast && (
        <div
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 1050,
            minWidth: "250px",
          }}
        >
          <Toast isOpen={showToast}>
            <ToastHeader icon="danger">Error</ToastHeader>
            <ToastBody>{toastMsg}</ToastBody>
          </Toast>
        </div>
      )}

      {!companiesLoading && !isError && (
        <MaterialReactTable
          columns={columns}
          data={companies}
          muiTablePaperProps={{
            elevation: 10,
          }}
        />
      )}

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg">
        <ModalHeader className="primary-color fw-bold" toggle={() => setModalOpen(!modalOpen)}>
          Feedback by {selectedUser?.name}
        </ModalHeader>
        <ModalBody>
          {selectedUser?.message != "" ? (
            <div>{selectedUser?.message}</div>
          ) : (
            <p>Feedback not found.</p>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default Feedbacks